export default "__VITE_ASSET__BpnqJIp5__"